import { createFileRoute } from "@tanstack/react-router"

import { PageDetailsPanel } from "@repo/ui/components/ui/page-details-panel"
import { PendingInvitations } from "~/modules/invitations/components/pending-invitations"
import { INTERNAL_SYSTEM_ROLE_ID } from "~/modules/roles-and-permissions/constants"
import { UnitMembers } from "~/modules/units/components/unit-members"

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/_admin-layout/system-config/users",
)({
  component: SystemConfigUsers,
})

function SystemConfigUsers() {
  const { internalAccount, user } = Route.useRouteContext()

  return (
    <PageDetailsPanel title="System Users">
      <div className="space-y-6">
        <PendingInvitations
          unitId={internalAccount.unit_id}
          systemRoleId={INTERNAL_SYSTEM_ROLE_ID}
        />

        <UnitMembers unitId={internalAccount.unit_id} currentUser={user} />
      </div>
    </PageDetailsPanel>
  )
}
